import React, { useCallback, useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { formatMessage } from 'locale'
import { useMetricsLog } from 'helpers/uilogging/hooks'
import { sendHoverSoundCommand, sendCancelClickSoundCommand } from 'react-wot-bootstrap'

import { KEY_CODES } from 'constants'
import { SEARCH_INPUT_MIN_LENGTH, SEARCH_INPUT_MAX_LENGTH } from '../../constants'
import { Actions, FEATURE, Items } from 'containers/Landing/logConstants'
import {
    SEARCH_CONTROL,
    SEARCH_CONTROL_EMPTY,
    SEARCH_CONTROL_SINGLE_LETTER,
    SEARCH_CONTROL_ENTER,
} from './translations'
import TextPlate from '../TextPlate/TextPlate'

import styles from './SearchControl.scss'

const SearchControl = ({ setSearchTerm, partnerID, searchTerm }) => {
    const log = useMetricsLog(FEATURE)
    const logSearch = useCallback(
        (item, info = null) => {
            log({
                action: Actions.Click,
                item,
                parentScreen: Items.LandingClans,
                partnerID: partnerID,
                info,
            })
        },
        [log]
    )

    const [inputValue, setInputValue] = useState('')
    const [isFocused, setFocused] = useState(false)
    const [isEnterPressed, setEnterPressed] = useState(false)

    const hasInput = inputValue !== ''

    const valueWithoutSpaces = inputValue ? inputValue.trim() : ''

    const isEnoughLetters = [...valueWithoutSpaces].length >= SEARCH_INPUT_MIN_LENGTH

    const handleChange = (event) => {
        setInputValue([...event.target.value].slice(0, SEARCH_INPUT_MAX_LENGTH).join(''))
        setEnterPressed(false)
    }

    const handleClearClick = () => {
        if (!hasInput && searchTerm === null) return
        setInputValue('')
        setSearchTerm(null)
        logSearch(Items.ClearSearchTextField)
        sendCancelClickSoundCommand()
    }

    const handleFocus = () => {
        setFocused(true)
        logSearch(Items.FocusSearchTextField)
    }

    const handleBlur = () => {
        setFocused(false)
    }

    const handleKeyUp = (e) => {
        if (e.keyCode === KEY_CODES.ENTER && isEnoughLetters && !isEnterPressed) {
            setSearchTerm(inputValue)
            document.activeElement.blur()
            setEnterPressed(true)

            const info = JSON.stringify({
                type: 'search',
            })
            logSearch(Items.SubmitSearchTextField, info)
        }
    }

    return (
        <div className={styles.search}>
            <div className={styles.inputContainer}>
                <input
                    type="text"
                    className={styles.input}
                    value={inputValue}
                    placeholder={isFocused ? undefined : formatMessage(SEARCH_CONTROL.placeholder)}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onKeyUp={handleKeyUp}
                />
                <div className={styles.searchIcon} />
                <button
                    className={cx(styles.clear, hasInput && styles.clear__visible)}
                    onClick={hasInput ? handleClearClick : undefined}
                    onMouseEnter={hasInput ? sendHoverSoundCommand : undefined}
                />
                {isFocused && (
                    <TextPlate>
                        <Fragment>
                            {[...valueWithoutSpaces].length === 0 && SEARCH_CONTROL_EMPTY}
                            {[...valueWithoutSpaces].length === 1 && SEARCH_CONTROL_SINGLE_LETTER}
                            {isEnoughLetters && SEARCH_CONTROL_ENTER}
                        </Fragment>
                    </TextPlate>
                )}
            </div>
        </div>
    )
}

SearchControl.propTypes = {
    setSearchTerm: PropTypes.func.isRequired,
    partnerID: PropTypes.string.isRequired,
    searchTerm: PropTypes.string,
}

export default SearchControl



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/SearchControl/SearchControl.jsx